import { http } from './httpClient'
import type { Paginated, User } from './types'

export interface UserSearchParams {
  q: string
  limit?: number
  offset?: number
}

export const userApi = {
  search: (params: UserSearchParams) =>
    http.get<Paginated<User>>('/api/users/', { query: { ...params } }),
}
